// src/api/collectorApi.js
import axios from "axios";
import axiosInstance from "./axiosInstance";

// login: returns axios response (response.data available)
 
// export const forgotPasswordCollector = (data) => {
//   return axiosInstance.post("/auth/forgot-password", data); 
// };

export const loginCollector = (payload) => {
  // console.log("loginCollector called with:", payload);
  return axiosInstance.post("/auth/admin/login", payload);
};

// dashboard overview
export const getOverviewAnalytics = async () => {
  try {
    const response = await axiosInstance.get("/analytics/overview");
    
    // console.log("API raw response:", response.data);
    return response.data;
  } catch (err) {
    console.error("API call error:", err);
    throw err; // re-throw so caller can catch
  }
};

// grievance pending data
export const grievancePendingData= async () => {
  try {
    const response = await axiosInstance.get("/grievances?status=pending&sortBy=createdAt&sortOrder=asc");
    
    // console.log("API raw response:", response.data);
    return response.data;
  } catch (err) {
    console.error("API call error:", err);
    throw err; // re-throw so caller can catch
  }
};


export const getDeptPendingComplaints = async (deptId) => {
  try {
    const response = await axiosInstance.get(
      `/grievances?departmentId=${deptId}&status=pending&sortBy=createdAt&sortOrder=asc`
    );

    return response.data?.data?.grievances || [];
  } catch (error) {
    console.error("Error fetching dept grievances:", error);
    throw error;
  }
};


export const departmentOfficeData = async () => {
  try {
    const res = await axiosInstance.get("/analytics/department-wise");
    return res.data?.data || [];
  } catch (error) {
    console.error("Department-wise error", error);
    throw error;
  }
};
export const getDepartmentDetails = async (departmentId) => {
  try {
    const res = await axiosInstance.get(
      `/analytics/department-details/${departmentId}`
    );
        return res.data?.data?.grievances || [];
  } catch (error) {
    console.error("Department details error", error);
    throw error;
  }
};


//officer-wise data
export const officerWiseData =async ()=>{
  try {
    const response = await axiosInstance.get("/analytics/officer-wise");
    // console.log("Dept response:", response.data);
    return response.data?.data || []; // return the array directly
  } catch (error) {
    console.error("OfficerData error:",error)
    throw error;
  }
}

//officer trends 

export const getOfficerTrends = async (officerId) => {
  try {
    const response = await axiosInstance.get(
      `/officers/${officerId}/trends`
    );
    return response.data?.data || null;
  } catch (error) {
    console.error("Officer Trends API Error:", error);
    return null;
  }
};


// officer pending complaint list
export const getOfficerPendingComplaints = async (officerId) => {
  try {
    const response = await axiosInstance.get(
      `/grievances?assignedOfficerId=${officerId}&status=pending&sortBy=createdAt&sortOrder=asc`
    );

    return response.data?.data?.grievances || [];
  } catch (err) {
    console.error("Officer Pending API Error:", err);
    return [];
  }
};

// officer-wise filtered by date 
export const getOfficerWiseByDate = async (from, to) => {
  try {
    const url = `/analytics/officer-wise?dateFrom=${from}&dateTo=${to}&sortBy=createdAt&sortOrder=desc`;
    // console.log("Officer-wise Filter API URL:", url);

    const response = await axiosInstance.get(url);

    // console.log("Officer-wise Filter Response:", response.data);

    // Correct: officer-wise API returns full `data` object
    return response.data?.data || [];
  } catch (error) {
    console.error(
      "Officer-wise filter error:",
      error.response?.data || error.message
    );
    return [];
  }
};

//daywiseTrends

export const daywiseTrends =async ()=>{
  try {
    const response = await axiosInstance.get("/analytics/trends");
    // console.log("Dept response:", response.data);
    return response.data?.data || []; // return the array directly
  } catch (error) {
    console.error("OfficerData error:",error)
    throw error;
  }
} 

// Departments
export async function getDepartments() {
  try {
    const response = await axiosInstance.get("/departments");
    // console.log("Departments API response:", response.data);
    return response.data?.data?.departments || [];
  } catch (err) {
    console.error("Departments API Error:", err);
    return [];
  }
}

// ✅ NEW FUNCTION - Get officers list for assignment (with optional department filter)
export const getOfficersForAssignment = async (departmentName = null) => {
  try {
    let url = "/grievances/officers";
    
    // Add department filter if provided and not "ALL"
    if (departmentName && departmentName !== "ALL") {
      url += `?department=${encodeURIComponent(departmentName)}`;
    }
    
    const response = await axiosInstance.get(url);
    // console.log("Officers for assignment response:", response.data);
    return response.data?.data?.officers || [];
  } catch (err) {
    console.error("Officers for assignment API Error:", err);
    return [];
  }
};

//priority
export const getCriticalAlerts = async () => {
  try {
    const response = await axiosInstance.get("/analytics/critical-alerts");
    return response.data?.data?.alerts || [];
  } catch (error) {
    console.error("Critical Alerts API Error:", error);
    return [];
  }
};

// heatmap count 


export const getBlockHeatmap = () => {
  const data = axiosInstance.get("/analytics/heatmap/block");
  return data;
}
  



// ✅ Admin: Add remarks only
export const addGrievanceRemarks = async (grievanceId, status, remarks) => {
  try {
    const response = await axiosInstance.put(
      `/grievances/${grievanceId}/status`,
      {
        status,                 
        remarks: remarks.trim() 
      }
    );

    return response.data;
  } catch (error) {
    console.error("Add remarks error:", error.response?.data);
    throw error;
  }


  
};

export const forgotPasswordCollector = (data) => {
  return axiosInstance.post("/auth/admin/forgot-password", data);
};

// Reset Password with OTP
export const resetCollectorPassword = (data) => {
  return axiosInstance.post("/auth/admin/reset-password", data);
};